import React from 'react';
import { Divider, Drawer, Switch, Typography } from '@dls/react-core';
import { IconButton } from '@material-ui/core';
import { Icon } from '@dls/react-icon';
import { MeasurementList } from './measurement-list';
import styled, { css } from 'styled-components';
import { MeasurementType } from '../../../api/studykit';
import { usePermission } from '../../../context/authorization';

export interface Settings {
  showGaps: boolean;
}

interface SidebarProps {
  open: boolean;
  onClose: () => void;
  onSelection: (selected: boolean, type: MeasurementType) => void;
  selected: MeasurementType[];
  measurementTypes: MeasurementType[];
  settings: Settings;
  onSettingsChange: (settings: Settings) => void;
}

const StyledDrawer = styled(Drawer)`
  width: 250px;
  margin-right: 0 !important;

  ${(props) =>
    !props.open &&
    css`
      width: 0;
    `}
`;

const SidebarSettingsPanel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const Sidebar: React.FC<SidebarProps> = ({
  open,
  onClose,
  onSelection,
  selected,
  measurementTypes,
  settings,
  onSettingsChange,
}) => {
  const canQueryData = usePermission('SubjectsData.Query');

  return (
    <StyledDrawer
      variant="persistent"
      anchor="left"
      open={open}
      PaperProps={{ style: { padding: 24, paddingTop: 0 } }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: 64,
        }}
      >
        <Typography as="h3">Metrics</Typography>
        <IconButton edge="end" onClick={onClose}>
          <Icon name="Cross32" size="m" />
        </IconButton>
      </div>
      <Divider />
      {canQueryData ? (
        <>
          <SidebarSettingsPanel>
            <Typography>Show gaps</Typography>
            <Switch
              size={'small'}
              checked={settings.showGaps}
              onChange={(e) => onSettingsChange({ ...settings, showGaps: e.target.checked })}
            />
          </SidebarSettingsPanel>
          <Divider style={{ marginBottom: 10 }} />
          <MeasurementList
            onSelection={onSelection}
            selected={selected}
            options={measurementTypes}
          />
        </>
      ) : (
        <Typography style={{ marginTop: 24 }}>You are not allowed to query data</Typography>
      )}
    </StyledDrawer>
  );
};
